import React, {useEffect, useState} from "react";
import {WidgetProps} from "../../../../../core/ui/widget/widget";
import {useTranslation} from "react-i18next";
import {Select} from "antd";
import {articlesService} from "../../../../../../services/articles/articles.service";
import {Group} from "../../../../../../models/articles/groups/group";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface UIInputWidgetGroupProps extends WidgetProps {
    onClear?: () => void;
    onSelect?: () => void;
}

export const UIInputWidgetGroup: React.FC<UIInputWidgetGroupProps> = ({value, onChange, multiple, onClear, onSelect}) => {

    const {t} = useTranslation('translation', {useSuspense: false});

    const [values, setValues] = useState<Group[]>([]);

    useEffect(() => {
        articlesService.getGroups().then(values => setValues(values))
    }, [])

    return (
        <Select
            className="selects_block_select"
            showSearch
            dropdownMatchSelectWidth={200}
            optionFilterProp={"children"}
            onSelect={onSelect}
            onClear={onClear}
            allowClear
            placeholder={t("GROUP.TITLE")}
            value={value}
            onChange={onChange}
        >
            {values.map(({id, name}) => (
                <Select.Option key={id} value={id}>{name}</Select.Option>
            ))}
        </Select>
    )
}